// ------------------------------------
// Constants
// ------------------------------------
export const APPLICATIONS_DELETE_REQUEST = "APPLICATIONS_DELETE_REQUEST";
export const APPLICATIONS_DELETE_REQUEST_SUCCESS =
  "APPLICATIONS_DELETE_REQUEST_SUCCESS";
export const APPLICATIONS_DELETE_REQUEST_FAILURE =
  "APPLICATIONS_DELETE_REQUEST_FAILURE";
export const APPLICATIONS_DELETE_RESET = "APPLICATIONS_DELETE_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: APPLICATIONS_DELETE_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(res, payload) {
  return {
    type: APPLICATIONS_DELETE_REQUEST_SUCCESS,
    data: res,
    payload,
  };
}

export function requestFailure(error, payload) {
  return {
    type: APPLICATIONS_DELETE_REQUEST_FAILURE,
    error,
    payload,
  };
}
